<template>
    <div class="content__text-block">
      <h1 class="h1">För publik</h1>
      <p>
        Här kommer inom kort all information som är relevant för publik att finnas
      </p>
    </div>
</template>

<script>
export default {
  Name: 'Audience',
  components: {
  },

  mounted() {

  }
}
</script>